import { createMetricsFactory } from 'metrics-js';

const NAME = 'persist-promise';

export const Metrics = createMetricsFactory(NAME, {
  library: NAME,
});
